import { gql } from "gql";

export const CREATE_COMPANY_DOCUMENT_CONFIRMATION_FOR_ACTIVE_PERSONS = gql(
  /* GraphQL */ `
    mutation CreateCompanyDocumentConfirmationsForActivePersons(
      $documentId: ID!
    ) {
      createCompanyDocumentConfirmationsForActivePersons(
        documentId: $documentId
      )
    }
  `,
);
